import { Id } from "src/utils/types";
import { request } from ".";

export type CreateCompnayRequestPayload = {
  requested_by_user_id: Id;
  requested_by_company_id: Id;
  request_type: string;
  message: string;
  collaborators_ids: number[];
}

export type CompanyRequest = {
  id: number;
  solicitado_pelo_usuario_id: number;
  solicitado_pelo_usuario_nome: string;
  solicitado_pela_empresa_id: number;
  solicitado_pela_empresa_nome: string;
  tipo: string;
  resolvido: boolean;
  mensagem: string;
  criado_em: string;
  atualizado_em: string|null;
  solicitado_para_colaboradores: string[]|null;
};

export const companyRequestReadableTypes: {[key: string]: string} = {
  SERVICE: 'Atendimento',
  EMERGENCY: 'Atendimento Emergêncial',
  ACTION: 'Ação ou Evento',
};

export const createCompanyRequest = async (payload: CreateCompnayRequestPayload): Promise<void> => {
  await request.post('/company-requests', payload)
}

export const markCompanyRequestAsResolved = async (companyRequestId: Id): Promise<void> => {
  await request.put(`/company-requests/${companyRequestId}/resolve`)
}

export const getCompanyRequestsForCompany = async (companyId: Id, status: string): Promise<CompanyRequest[]> => {
  const response = await request.get<CompanyRequest[]>(`/company-requests`, {
    params: {
      company_id: companyId,
      status: status,
    },
  })

  if (!response) {
    return []
  }

  return response.data
}
